import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import {
    createStyles, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, Icon,
    IconButton, Input, InputAdornment, InputLabel, makeStyles, MenuItem, Radio, RadioGroup, Select, TextField, Theme, Typography
} from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { InfluencerContext } from '../NewsContext';

import { ClassificationInfluencerModel } from '../../../Models/ClassificationInfluencerModel';
import { HomeContext } from '../../Home/HomeContext';
import { NewsLoadingContext } from '../NewsLoadingContext';
import { InfluencerModel } from '../../../Models/InfluencerModel';
import { ClassificationModel } from '../../../Models/ClassificationModel';
import { VehicleModel } from '../../../Models/VehicleModel';
import { ErrorStatus } from '../../../shared/enum/ErrorStatus';
import { DetachedClassificationAction } from '../enum/DetachedClassificationAction';

const useStyles = makeStyles((theme: Theme) => createStyles({
    itens: {
        width: '100%',
        color: 'primary',
    },
    itemData: {
        width: '100%',
        color: 'primary',
        paddingBottom: theme.spacing(1.5),

    },
    linkColor: {
        color: '#2C64D0',
        textOverflow: 'ellipsis',
        '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    editText: {
        textOverflow: 'ellipsis',
    },
    yellowBackground: {
        backgroundColor: theme.palette.warning.light
    },
    outsideGrid: {
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    loading: {
        minHeight: '20vh'
    },
    linksPaperError: {
        padding: theme.spacing(3),
        border: `1px solid ${theme.palette.error.main}`,
    },
    errorText: {
        paddingLeft: theme.spacing(2)
    }
}));

interface InfluencerDataQuestionsProps {
    news: InfluencerModel | null;
    setNews: (news: InfluencerModel) => void;
    newsCurrentId: number | null;
    setNewsCurrentId: (currentId: number | null) => void;
    questions: Record<string, any>;
    setQuestions: (questions: any) => void;
    errorQuestions: Record<string, any>;
    setErrorQuestions: (questions: any) => void;
    statusClassification: Record<string, any>;
    setStatusClassification: (questions: any) => void;
}

export default function InfluencerDataQuestions({
    news,
    setNews,
    newsCurrentId,
    setNewsCurrentId,
    questions,
    setQuestions,
    errorQuestions,
    setErrorQuestions,
    statusClassification,
    setStatusClassification,

}: InfluencerDataQuestionsProps) {
    const classes = useStyles();

    // const newsContext = React.useContext(InfluencerContext);
    const newsLoadingContext = React.useContext(NewsLoadingContext);
    const homeContext = React.useContext(HomeContext);


    const handleChangeInput = (prop: any) => (event: React.ChangeEvent<{ value: unknown }>) => {
        const newValue = event.target.value as string;

        setQuestions((prevQuestions: typeof questions) =>
            prevQuestions.map((q: any) =>
                q.id === prop ? { ...q, value: newValue } : q
            )
        );
    };

    const handleChangeBoard = (event: React.ChangeEvent<HTMLInputElement | any>) => {
        const updatedStatusClassification = { ...statusClassification };
        if (updatedStatusClassification) {
            updatedStatusClassification[newsCurrentId!]['statusClassificacao'] = event.target.value;
            return setStatusClassification(updatedStatusClassification);
        }
    };

    const handleChange = (prop: keyof InfluencerModel) => (event: React.ChangeEvent<HTMLInputElement> | any) => {

        if (prop == 'statusRevisor') {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            setNews({ ...news, [prop]: event.target.value });
        } else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            setNews({ ...news, [prop]: event });
        }
    };


    const getInputText = () => {
        return (
            newsCurrentId &&
            questions?.map((question: any) => {
                return question.tipo == 1 ?
                    <>
                        <Grid item xs={12}>
                            <TextField
                                id={question.id}
                                value={question.value ? question.value.toString() : ''}
                                onChange={handleChangeInput(question.id)}
                                label={question.description}
                                variant="outlined"
                                className={classes.itens}
                            />
                        </Grid>
                    </>
                    : null;
            })
        );
    };
    const getInputRadio = () => {
        return (
            newsCurrentId &&
            questions?.map((question: any) => {
                const error = errorQuestions && errorQuestions[question.id];
                const showError = !!error;
                return question.tipo == 2 ? (
                    <Grid item xs={12} key={question.id}>
                        <FormControl error={showError}>
                            <FormLabel id={question.id}>{question.description}</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                onChange={handleChangeInput(question.id)}
                                value={question.value ? question.value.toString() : ''}
                            >
                                <FormControlLabel value="true" control={<Radio />} label="Sim" />
                                <FormControlLabel value="false" control={<Radio />} label="Não" />
                            </RadioGroup>
                            <FormHelperText>
                                {error ? error : ''}
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                ) : null;
            })
        );
    };



    return (
        <>
            <Grid>
                <Grid
                    container
                    spacing={3}
                    alignItems="flex-start" >
                    {getInputRadio()}
                    {getInputText()}
                </Grid>
            </Grid>
        </>
    );
}